import ResizeImageModal from './ResizeImageModal';

export default ResizeImageModal;
